import { router } from '../router/routes'
import Vue from 'vue'

function addFilters(filters){
  Object.keys(filters).forEach(function(key) {
    Vue.filter(key, filters[key]);
  });
}

function dropQueryParamByReplaceToLocation(location){
  if(!isEmpty(router.history.current.query)) {
    router.replace(location)
  }
}
function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

function getRouterQueryParam(key){
  const routerQuery = router.app._route.query;
  // eslint-disable-next-line no-prototype-builtins
  if(routerQuery.hasOwnProperty(key)){
    return routerQuery[key];
  }
}
function urlWithQueryString(url, ...queryArgs) {
  const first = 0;
  queryArgs.forEach((arg, index) => {
    if (Object.values(arg) && Object.values(arg)[first]) {
      url += (index === first ? '?' : '&');
      url += Object.keys(arg)[first] + '=' + Object.values(arg)[first];
    }
  });
  return url;
}

export function isDevMode() {
  return process.env.NODE_ENV === 'development'
}

/*function translateWithAdditionalKey(key,additionalKey, param=undefined){
  if(!Object.keys(i18n.t(key)).includes(additionalKey+"")){
    additionalKey = 'default';
  }
  return translate(key+'.'+additionalKey,param);
}

function translate(key,param=undefined) {
  return i18n.t(key,param);
}*/

function noRefCopyArray(array){
  return JSON.parse(JSON.stringify(array));
}

export function isIos(){
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function scrollTo(element, to, duration, stopScrollElementClassName = null, validateAction = () => {return false;}) {
  if(validateAction() || duration <= 0) {
    return false;
  }

  stopScrollElementClassName ? checkScrollUpAndStop() : undefined;

  const difference = to - element.scrollTop;
  const perTick = difference / duration * 10;

  const timeout = setTimeout(function() {
    element.scrollTop = element.scrollTop + perTick;

    if (validateAction() || element.scrollTop === to) {
      clearTimeout(this);
      return;
    }

    scrollTo(element, to, duration - 10, stopScrollElementClassName, validateAction);
  }, 10);

  function checkScrollUpAndStop() {
    let position = document.querySelector(stopScrollElementClassName).scrollTop;
    document.querySelector(stopScrollElementClassName).addEventListener('scroll', scrollEvent);

    function scrollEvent() {
      const scroll = document.querySelector(stopScrollElementClassName).scrollTop;
      if(scroll < position) {
        clearTimeout(timeout);
        window.removeEventListener('scroll', scrollEvent);
      }
      position = scroll;
    }
    /*$(stopScrollElementClassName).scroll(function() {
      const scroll = $(stopScrollElementClassName).scrollTop();
      if(scroll < position) {
        clearTimeout(timeout)
      }
      position = scroll;
    });*/
  }
}

export function create_UUID(){
  let dt = new Date().getTime();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}


export {urlWithQueryString, dropQueryParamByReplaceToLocation, getRouterQueryParam, noRefCopyArray, addFilters}
